// import PropTypes from "prop-types";
import { useContext } from "react";

import { withALErrorBoundary } from "@helpers/ErrorBoundary/ALErrorBoundary";

import { CartContext } from "@context/CartProvider";
import { cn } from "@helpers/general";

import useSticky from "@hooks/useSticky";
import useResponsiveWithHydrationFix from "@hooks/useResponsiveWithHydrationFix";

import { ALLogo } from "@components/ALComponents";
import CountdownTimer from "@components/CountdownTimer";

import IconCart from "@svgs/cart2025.svg";

function HeaderByob() {
  const offsetHeader = useSticky(true);
  const { itemsInCart, toggleCart, isSideCartOpen } = useContext(CartContext);

  const cartContent = useResponsiveWithHydrationFix(
    <button
      className="relative hidden mobile:block"
      onClick={toggleCart}
      aria-label="cart"
      tabIndex={0}
      type="button"
    >
      <IconCart stroke="#000000" />
      {itemsInCart > 0 && (
        <span className="absolute text-[7px] font-bold top-[7px] left-[7px]">{itemsInCart}</span>
      )}
    </button>,
    <button
      className="relative hidden desktop:block h-[21px] w-[21px]"
      onClick={toggleCart}
      aria-label="cart"
      tabIndex={0}
      type="button"
    >
      <IconCart width="21px" height="21px" stroke="#000000" />
      {itemsInCart > 0 && (
        <span className="absolute text-[9px] top-[7px] left-[8px] font-bold">{itemsInCart}</span>
      )}
    </button>
  );

  return (
    <header
      id="header"
      className="sticky bg-white border-b border-dark-grey transition-all ease-out duration-300"
      style={{
        ...offsetHeader,
        zIndex: isSideCartOpen ? 999 : 98,
      }}
    >
      <div
        className={cn(
          "flex items-center justify-between",
          "px-[1.74vw] pt-[15px] pb-[20px] mobile:px-[15px] mobile:py-[18px]"
        )}
      >
        <ALLogo className="h-[37px] mobile:h-[18px]" />
        <div className="flex items-end gap-[20px] mobile:gap-[10px]">
          <div className="flex gap-[5px]">
            <p className="typo-body m-0">Limited-Time Only:</p>
            <CountdownTimer hours={0} minutes={59} seconds={59} />
          </div>
          {itemsInCart >= 2 ? (
            cartContent
          ) : (
            <div className="h-[21px] w-[21px] mobile:h-[19px] w-[19px]">&nbsp;</div>
          )}
        </div>
      </div>
    </header>
  );
}

export default withALErrorBoundary({
  name: "HeaderByob",
  priority: "P1",
})(HeaderByob);
